import { useStore } from 'zustand'
import { useShallow } from 'zustand/react/shallow'
import { useProductListContext } from '../useProductListContext/useProductListContext'

// Main hook for static data only
export const useProductList = () => {
	const { productListStore } = useProductListContext()
	return useStore(
		productListStore,
		useShallow((state) => ({
			defaultView: state.defaultView,
			initialCount: state.initialCount,
			name: state.name,
			total: state.total,
			shouldRenderSlideshowAnimation: state.shouldRenderSlideshowAnimation,
			hasInspirationalPresentation: state.hasInspirationalPresentation,
			setView: state.setView,
			setCount: state.setCount,
			increaseCount: state.increaseCount,
			resetCount: state.resetCount,
			setSlideshowAnimationRendered: state.setSlideshowAnimationRendered,
			restoreStoredState: state.restoreStoredState,
		}))
	)
}

// Individual state selectors
export const useProductListView = () => {
	const { productListStore } = useProductListContext()
	return useStore(productListStore, (state) => state.view)
}

export const useProductListCount = () => {
	const { productListStore } = useProductListContext()
	return useStore(productListStore, (state) => state.count)
}

export const useProductListStoredState = () => {
	const { productListStore } = useProductListContext()
	return useStore(productListStore, (state) => state.storedState)
}

export const useProductListLastSlotId = () => {
	const { productListStore } = useProductListContext()
	return useStore(productListStore, (state) => state.lastSlotId)
}

export const useProductListSlideshowAnimationRendered = () => {
	const { productListStore } = useProductListContext()
	return useStore(productListStore, (state) => state.slideshowAnimationRendered)
}
